import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useErrorHandler } from 'react-error-boundary';
import { useSelector } from 'react-redux';

import { useDidMount } from '../../customHooks';

import { ReserveHeader } from '../../components/Header';
import { Footer } from '../../components/Footer';
import TopicPath from '../../components/TopicPath';

import CancelApi from '../../api/reserveChange/cancel';
import operationalLogs from '../../api/log/operationalLogs';

const Cancel = function () {
  const navigate = useNavigate();
  const handleError = useErrorHandler();

  const location = useLocation();
  const state = location.state ?? '';
  const {
    changeUrl = '',
    receptionId = '',
    lgCd = '',
    rsvNumber = '',
    placeName = '',
    rsvDate = '',
  } = state;

  const rsvSetId = useSelector((state) => state.reserveChange.rsvSetId);

  const [stateCancel, setCancel] = useState([]);
  const [stateReason, setReason] = useState('');

  const [checkReason, setCheckReason] = useState(false);

  useEffect(() => {
    if (stateReason.length > 200) {
      setCheckReason(true);
    } else {
      setCheckReason(false);
    }
  }, [stateReason]);

  /**
   * checkBoxの状態が変化したときの処理
   * @param {*} i
   */
  const changeCheckBox = (i) => {
    const replaceData = {
      flag: !stateCancel[i].flag,
      cancelId: stateCancel[i].cancelId,
      cancelReason: stateCancel[i].cancelReason,
    };
    const copyList = [...stateCancel];
    copyList.splice(i, 1, replaceData);
    setCancel(copyList);
  };

  const createList = () => {
    const list = [];
    for (let i = 0; i < stateCancel.length; i += 1) {
      const { flag, cancelId, cancelReason } = stateCancel[i];
      list.push(
        <p>
          <input id={cancelId} type="checkbox" checked={flag} onChange={() => changeCheckBox(i)} />
          <label htmlFor={cancelId}>{cancelReason}</label>
        </p>
      );
    }
    return <ul style={{ marginLeft: 0 }}>{list}</ul>;
  };

  const initialProcess = async () => {
    try {
      const getCancel = await CancelApi.findByRsvSetId(rsvSetId);
      const { cancel } = getCancel;
      setCancel(cancel);
    } catch (err) {
      handleError(err);
    }
  };

  useDidMount(() => {
    initialProcess();
  });

  const updateReception = async () => {
    if (window.confirm('予約キャンセルを確定します。よろしいですか？')) {
      if (checkReason) {
        return window.alert('理由などの詳細は200文字以内で入力してください。');
      }
      // stateCancelの成形はcontrollerでしている
      try {
        await CancelApi.updateReception(receptionId, '4', stateCancel, stateReason);
        // 処理完了後はTopに戻したいためセッションストレージから削除
        sessionStorage.removeItem('changeUrl');
        navigate('/change/cancel/cmplt', {
          state: { lgCd, rsvNumber, placeName, rsvDate },
        });

        // 処理記録
        operationalLogs.createOprLogs('', '', '040002001', 'RsvOnlyWithoutUser', receptionId);
      } catch {
        window.alert('予約のキャンセルに失敗しました。');
      }
    }
  };

  return (
    <>
      <ReserveHeader servCd="reserve" lgCd={lgCd} />
      <div id="container">
        <TopicPath />
        <main>
          <article>
            <div id="contents">
              <div className="inner">
                <h2>予約のキャンセル</h2>
                <p className="txtCenter mb40">キャンセルの理由を選択してください。（任意）</p>
                <div className="inner450">
                  {createList()}
                  <p className="mt20 mb10">理由などの詳細がありましたら、入力してください。</p>
                  <textarea
                    placeholder="200文字以内、任意"
                    defaultValue={stateReason}
                    onBlur={(e) => {
                      setReason(e.target.value);
                    }}
                  />
                  <p className="mt40">
                    「予約をキャンセルする」ボタンをクリックすると、
                    <br />
                    予約のキャンセルを確定します。
                  </p>
                </div>
                <ul id="navi" className="row jcSB">
                  <li className="col2">
                    <a
                      className="btn btBack"
                      onClick={() => {
                        navigate(`/change/${changeUrl}`);
                      }}
                    >
                      前に戻る
                    </a>
                  </li>
                  <li className="col2 mr0 row jcFE">
                    <a
                      className="btn btNext"
                      onClick={() => {
                        updateReception();
                      }}
                    >
                      予約をキャンセルする
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </article>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default Cancel;
